const $ = require('jquery');
const _ = require('lodash');
const pjax = require('./pjax');
const modal = require('./modal');
const unveil = require('unveil');
const FlashMessageStore = require('./../flux/stores/FlashMessageStore');

const maxUploadFileSizeMb = _.get(globals, 'maxUploadFileSizeMb', 5);

module.exports = {
  init() {
    const self = this;
    $('.discussionBlock-lazyload').unveil();

    //
    $(document).off('click', '.delete-image');
    $(document).on('click', '.delete-image', (e) => {
      e.preventDefault();

      modal.confirm(_.get(translations, 'txt: Vai tiešām dzēst?', ''), (response) => {
        if (response) {
          window.location.href = e.currentTarget.href;
        }
      });
    });

    //
    $(document).off('click', '.delete-profile-image');
    $(document).on('click', '.delete-profile-image', (e) => {
      e.preventDefault();

      modal.alert(_.get(translations, 'txt: Šo bildi nevar dzēst, jo tā ir iestatīta kā profila fotogrāfija', ''), _.get(translations, 'txt: Sapratu', ''));
    });

    //
    $(document).off('click', '.remove-profile-image');
    $(document).on('click', '.remove-profile-image', (e) => {
      e.preventDefault();

      modal.confirm(_.get(translations, 'txt: Vai tiešām noņemt profila fotogrāfiju?', ''), (response) => {
        if (response) {
          window.location.href = e.currentTarget.href;
        }
      });
    });

    //
    const dontTrigger = $('.image_upload_files').data('dont-trigger') || false;
    const replaceInfo = $('.image_upload_files').data('replace-info') || false;
    this.initUploader(dontTrigger, replaceInfo);
    if (!dontTrigger) {
      this.importExternalPicture();
    }

    // lai izlabotu background bildes dīvaino uzvedību uz mobilajām ierīcēm
    if (_.get(globals, 'mobile', false)) {
      $(document).on('ready pjax:success', () => {
        $('.background').css('height', 0);
        $('.background').css('height', '100%');
      });
    }
  },
  triggerUpload() {
    document.querySelectorAll('.image_upload_submit')[0].click();
  },
  // bilžu pievienošana
  initUploader(dontTrigger, replaceInfo) {
    const _this = this;
    $(document).on('pjax:beforeReplace', () => {
      $(document).off('change', '.image_upload_files');
    });
    $(document).on('change', '.image_upload_files', function () {
      if ($(this).data('loader')) {
        $('.imageUploadOptions').hide();
        $('#vex-content').append(`<div id="vex-content"><div class="loader"><div class="loader-icon"></div><div class="loader-text">${_.get(translations, 'please_wait', '')}</div></div></div>`);
      }

      const filesList = $(this).prop('files');
      const uploadSubmit = $('.image_upload_submit');

      let event = 'click ';
      if (Modernizr.touch) {
        event = `${event} touchstart`;
      }

      // neizdodas iegūt files datus
      if (_.isEmpty(filesList)) {
        // trigerojam submit, jo uz IE9 nevar iegūt fileList
        if (!dontTrigger) {
          _this.triggerUpload();
        }
        return;
      }

      // nav izvēlēts fails
      if (filesList.length === 0) {
        return false;
      }

      let stopUpload = false;
      $.each(filesList, (index, object) => {
        const sizeInBytes = _.get(object, 'size', false);

        // Size not valid
        if (!sizeInBytes || sizeInBytes / (1024*1024) > maxUploadFileSizeMb) {
          // Prepare error message
          const errorText = !sizeInBytes ? 'txt: Nevarējām iegūt datus par bildes faila izmēru' : 'txt: Bilde par lielu. Maksimālais pieļaujamais bildes faila izmērs {:size} megabaiti.';
          let errorMessage = _.get(translations, errorText, errorText);
          if (errorMessage.includes('{:size}')) {
              errorMessage = errorMessage.replace('{:size}', maxUploadFileSizeMb);
          }
          // Show error flash message
          const filename = _.get(object, 'name', '');
          FlashMessageStore.removeAll();
          FlashMessageStore.add(`${String(Date.now())}_${filename}`, 'error', `${errorMessage} (${filename})`, {
            parentClass: 'flash-container'
          });
          FlashMessageStore.emitChange();
          stopUpload = true;
          return;
        }
      });

      if (stopUpload) {
        $('.vex-upload-popup').remove();
        return;
      }

      // trigero submit pogas nospiešanu
      if (!dontTrigger) {
        _this.triggerUpload();
      }

      const uploadInfo = $('#filelist'); // attēlos info par augšuielādes failiem

      // parāda sarakstu ar failiem, kuriem notiek augšupielāde
      if (replaceInfo) {
        uploadInfo.html('');
      }
      $.each(filesList, (index, object) => {
        if (!_.isEmpty(object.name)) {
          uploadInfo.append(`<div class="fileList-group"><span class="fileList-group-name">${object.name}</span></div>`);
        }
      });

      // aktivizē loader
      uploadInfo.addClass('is-loader');

      // images blokam uzliek loading slāni
      $('#images').addClass('loading');

      $('.vex-upload-popup').remove();
    });
  },

  importExternalPicture() {
    $(document).on('click', '.imagesThumb-image--import', function (e) {
      e.preventDefault();
      if (!$(this).hasClass('imagesThumb-image--selected')) {
        $(this).addClass('imagesThumb-image--selected');
        $(this).parent().find('input').prop('checked', true);
      } else {
        $(this).removeClass('imagesThumb-image--selected');
        $(this).parent().find('input').prop('checked', false);
      }

      const count = $('.imagesThumb-image--selected').length;
      const regExp = /\(([^)]+)\)/;
      const importSelectedVal = regExp.exec($('.importSelected').val());

      $('.importSelected').val($('.importSelected').val().replace(importSelectedVal[1], count));
    });
  },
};
